import React from 'react';
import ReactOnRails from 'react-on-rails';

import ErrorBoundary from '@components/ErrorBoundary';

type AnyComponent = React.ComponentType<any>;

function registerWithErrorBoundary(components: Record<string, AnyComponent>) {
  const wrapped: Record<string, AnyComponent> = {};

  for (const [name, Component] of Object.entries(components)) {
    const Wrapped = (props: any) => (
      <ErrorBoundary componentName={name}>
        <Component {...props} />
      </ErrorBoundary>
    );
    Wrapped.displayName = `withErrorBoundary(${name})`;
    wrapped[name] = Wrapped;
  }

  ReactOnRails.register(wrapped);
}

export default registerWithErrorBoundary;
